'use client';
import React, { memo } from 'react';
import useApplyLogging from '../../hooks/useApplyLogging.mjs';

function IcTxtMainCategoryFinance(customProps) {
  const {
    fill,
    ...props
  } = customProps;
  useApplyLogging('ICON_IcTxtMainCategoryFinance');
  return /*#__PURE__*/React.createElement("svg", {
    width: "100%",
    height: "100%",
    viewBox: "0 0 37 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.8 8.6C15.08 6.78 15.22 4.84 15.22 3.26V2.02H2.1V4.36H12.66C12.62 5.38 12.48 7.02 12.22 8.6H0V10.86H17.6V8.6H14.8ZM15.56 20.18V12.76H2.06V20.18H15.56ZM13 14.96V17.94H4.6V14.96H13Z",
    fill: fill || 'black'
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1048 8.58C32.1648 8.58 34.3248 7.42 34.3248 5.08C34.3248 2.76 32.1648 1.64 29.1048 1.64H25.8448C22.7648 1.64 20.6248 2.76 20.6248 5.08C20.6248 7.42 22.7648 8.58 25.8448 8.58H29.1048ZM28.6248 3.76C30.6248 3.76 31.7648 4.2 31.7648 5.1C31.7648 6.02 30.6248 6.48 28.6248 6.48H26.3248C24.3048 6.48 23.1648 6.02 23.1648 5.1C23.1648 4.2 24.3048 3.76 26.3248 3.76H28.6248ZM36.2648 9.72H18.6648V11.9H22.9848V13.78C21.4048 14.34 20.5248 15.5 20.5248 16.9C20.5248 18.9 22.2648 20.36 25.2448 20.36H29.6848C32.6848 20.36 34.4248 18.9 34.4248 16.9C34.4248 15.5 33.5648 14.36 31.9848 13.8V11.9H36.2648V9.72ZM25.4648 13.44V11.9H29.5048V13.44H25.4648ZM25.7248 18.14C23.8648 18.14 23.0648 17.66 23.0648 16.88C23.0648 16.1 23.8648 15.64 25.7248 15.64H29.2248C31.0848 15.64 31.8648 16.1 31.8648 16.88C31.8648 17.66 31.0848 18.14 29.2248 18.14H25.7248Z",
    fill: fill || 'black'
  }));
}
var IcTxtMainCategoryFinance$1 = /*#__PURE__*/memo(IcTxtMainCategoryFinance);

export { IcTxtMainCategoryFinance$1 as default };
